<div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
        <div class="d-flex align-items-center contact-title-wrapper">
            <img src="assets/svg/functions-icon.svg" width="20" class="contact-section-icon">
            <h3 class="text-semibold contact-title">Funciones de contactos ({{contactos.length}})</h3>
        </div>
        <div class="justify-self-end">
            <button class="btn btn-link color-org" style="width: 97px; height: 38px; border-radius: 32px; border: 1px solid; background-color: #EA5A10; color: white;" (click)="navigateToFullTable()">
                Ver todos
            </button>
        </div>
    </div>
    <div class="divider-line mt-2"></div>
    @for(item of contactos; track item.contacto_id){
        <div class="d-grid contact-content-horizontal">
            <div class="d-flex align-items-center contact-name-wrapper">
                <img src="assets/svg/contact-icon.svg" width="24" class="contact-icon me-2">
                <u class="color-org contact-name" style="padding-left: 8px; font-weight: 400; font-size: 16px;">{{item.nombre}}  {{item.apellido}}</u>
            </div>
            
            <div class="contact-detail-item">
                <div class="detail-label">Función:</div>
                <div class="detail-value">{{item.funcion}}</div>
            </div>

            <div class="contact-detail-item">
                <div class="detail-label">Cargo:</div>
                <div class="detail-value">{{item.cargo}}</div>
            </div>
        </div>
    }
</div>